var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"http://metaverse.payfoot.com/","target":"_blank"}},[_c('v-img',{staticClass:"rounded-lg",attrs:{"src":require('@/assets/images/metaverse-banner-aside.png'),"max-width":"280"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }